import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

export class AcceptHeaderInterceptor implements HttpInterceptor {

  constructor(private acceptHeader: string) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Accept: this.acceptHeader
      },
    });
    return next.handle(request);
  }
}
